import '../css/app.scss'
import '../css/tailwind.css'
import '../css/sections/hero-banner.scss'
import '../css/sections/home.scss'
import '../css/sections/main-product.scss'

import '../../scripts/sections/announcement-bar.js'
import '../../scripts/sections/header.js'
import '../../scripts/sections/lazyloading.js'
import '../../scripts/sections/countdown-bar.js'
import '../../scripts/sections/collection-filters-form.js'
import '../../scripts/sections/blog-filters.js'
import '../../scripts/sections/product-bundle.js'
import '../../scripts/sections/product-gallery.js'
import '../../scripts/sections/product-gallery-style-2.js'
import '../../scripts/sections/product-bundle-options.js'
import '../../scripts/sections/mobile-filters.js'
import '../../scripts/sections/mobile-menu.js'
import '../../scripts/sections/hero-slider.js'
import '../../scripts/sections/video.js'
import '../../scripts/sections/featured-collections-carousel.js'
import '../../scripts/sections/footer.js'
import '../../scripts/sections/featured-blog.js'
import '../../scripts/sections/featured-youtube.js'
import '../../scripts/sections/side-cart.js'
import '../../scripts/sections/pdp-usp-slider.js'
import '../../scripts/sections/bundle.js'
import '../../scripts/sections/testimonial-slider.js'
import '../../scripts/sections/related-articles.js'
import '../../scripts/sections/stack-products.js'
import '../../scripts/sections/search-facets.js'
import '../../scripts/sections/homepage-carousel.js'
import '../../scripts/sections/multi-collection-slider.js'
import '../../scripts/sections/swiper-slider.js'
import '../../scripts/components/add-to-cart.js'
